<p>{{ 'labels.text.Please update your password' | translate }}:</p>

<mat-divider></mat-divider>

<form class="layout-column" [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()" id="reset-password-form">
  <mat-form-field class="reset-password-input flex-fill align-center">
    <span matPrefix>
      <fa-icon icon="lock" size="lg" class="m-r-10"></fa-icon>
    </span>
    <mat-label>{{ 'labels.inputs.Password' | translate }}</mat-label>
    <input type="{{ passwordInputType }}" matInput required formControlName="password" />
    @if (resetPasswordForm.controls.password.value && !loading) {
      <button
        mat-button
        matSuffix
        mat-icon-button
        (mousedown)="passwordInputType = 'text'"
        (mouseup)="passwordInputType = 'password'"
      >
        @if (passwordInputType === 'password') {
          <fa-icon icon="eye"></fa-icon>
        }
        @if (passwordInputType === 'text') {
          <fa-icon icon="eye-slash"></fa-icon>
        }
      </button>
    }
    @if (resetPasswordForm.controls.password.hasError('required')) {
      <mat-error>
        {{ 'labels.inputs.Password' | translate }} <strong>{{ 'labels.commons.is required' | translate }}</strong>
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field class="reset-password-input flex-fill align-center">
    <span matPrefix>
      <fa-icon icon="check-circle" size="lg" class="m-r-10"></fa-icon>
    </span>
    <mat-label>{{ 'labels.inputs.Confirm Password' | translate }}</mat-label>
    <input type="password" matInput required formControlName="repeatPassword" />
    @if (resetPasswordForm.controls.password.hasError('required')) {
      <mat-error>
        {{ 'labels.inputs.Password' | translate }} <strong>{{ 'labels.commons.is required' | translate }}</strong>
      </mat-error>
    }
    @if (resetPasswordForm.controls.password.hasError('minlength')) {
      <mat-error>
        {{ 'labels.commons.Password should be at least' | translate }}
        <strong>{{ 'labels.commons.12 characters long' | translate }}</strong>
      </mat-error>
    }
    @if (resetPasswordForm.controls.password.hasError('maxlength')) {
      <mat-error>
        {{ 'labels.commons.Password should not be more than' | translate }}
        <strong>{{ 'labels.commons.50 characters long' | translate }}</strong>
      </mat-error>
    }
    @if (
      resetPasswordForm.controls.password.hasError('pattern') &&
      !(
        resetPasswordForm.controls.password.hasError('minlength') ||
        resetPasswordForm.controls.password.hasError('maxlength')
      )
    ) {
      <mat-error>
        {{ 'labels.commons.Password should include a' | translate }}
        <strong>{{ 'labels.commons.numeral' | translate }}</strong> {{ 'labels.commons.and at' | translate }}
        <strong>{{ 'labels.commons.least one uppercase' | translate }}</strong> ,<strong>{{
          'labels.commons.lowercase and special character' | translate
        }}</strong>
      </mat-error>
    }
  </mat-form-field>

  @if (
    resetPasswordForm.errors?.passwordsDoNotMatch &&
    !resetPasswordForm.controls.password.hasError('required') &&
    !resetPasswordForm.controls.repeatPassword.hasError('required')
  ) {
    <p class="reset-password-error">
      {{ 'labels.text.Passwords' | translate }} <strong>{{ 'labels.text.do not match' | translate }}</strong>
    </p>
  }

  <button
    mat-raised-button
    color="primary"
    class="reset-password-button align-center"
    [disabled]="!resetPasswordForm.valid"
  >
    {{ 'labels.buttons.Reset Password' | translate }}
    @if (loading) {
      <mat-spinner [diameter]="20"></mat-spinner>
    }
  </button>
</form>
